import { takeLatest, put, call, select } from 'redux-saga/effects';
import { EXPORT_USERS_TO_EXCEL_SAGA } from "../sagaTypes";
import { loaderAction } from "../rootReducer";
import { url } from "../../config";
import { setLocalStorage } from "../../helpers/LocalStorage";
import growl from "../../lib/growl/growl";
import * as XLSX from "xlsx";

const request = data => {
    return fetch(`${ url }/export_users_to_excel`, {
        method: 'post',
        body: data
    })
        .then(response => response.json()).catch(error => console.log(error))
};

function* workerExportUsersToExcel(args) {
    const user = yield select(state => state.user);

    yield put(loaderAction(true));
    try {
        let formData = new FormData();
        formData.append('user_id', user.id);
        formData.append('hash', user.hash);
        formData.append('without_subscriptions', args.data.without_subscriptions || '');
        formData.append('expire_to', args.data.expire_to || '');
        formData.append('workouts_less_than', args.data.workouts_less_than || '');
        formData.append('registration_not_later', args.data.registration_not_later || '');
        formData.append('not_been_x_months', args.data.not_been_x_months || '');
        formData.append('last_workout_from', args.data.last_workout_from || '');
        formData.append('last_workout_to', args.data.last_workout_to || '');
        formData.append('birthday_from', args.data.birthday_from || '');
        formData.append('birthday_to', args.data.birthday_to || '');
        formData.append('admin', args.data.admin || '');
        formData.append('coach', args.data.coach || '');
        formData.append('workouts_count', args.data.workouts_count || '');
        formData.append('debt', args.data.debt);
        formData.append('without_workouts', args.data.without_workouts);

        const response = yield call (request, formData);

        // Если не прошли проверку хеша разлогиниваемся
        if (response?.void) {
            setLocalStorage('afp_fitness', '').then(() => window.location.reload());
        }
        else if (response?.error) {
            growl({ type: 'error', message: response.message });
        }
        else if (response?.success) {
            // Проверяем наличие элементов в массиве
            if (response.users.length) {
                let result = [Object.keys(response.users[0])];
                response.users.forEach(elem => {
                    result.push(Object.values(elem));
                });

                const ws = XLSX.utils.aoa_to_sheet(result);
                const wb = XLSX.utils.book_new();
                XLSX.utils.book_append_sheet(wb, ws, 'Клиенты');
                XLSX.writeFile(wb, `Клиенты.xlsx`);
            }
            else {
                growl({ type: 'warning', message: 'Нет записей' });
            }
        }
    }
    catch(error) {
        console.log(error);
        yield put(loaderAction(false));
    }
    finally {
        yield put(loaderAction(false));
    }
}

export default function* watcherExportUsersToExcel() {
    yield takeLatest(EXPORT_USERS_TO_EXCEL_SAGA, workerExportUsersToExcel);
}